import { Route, Routes } from 'react-router';

import { Layout } from './components/Layout.js';
import { AdminPage } from './pages/AdminPage.js';
import { ChatsPage } from './pages/ChatsPage.js';
import { HomePage } from './pages/HomePage.js';
import { NewsPage } from './pages/NewsPage.js';
import { NewsPostPage } from './pages/NewsPostPage.js';
import { NotFoundPage } from './pages/NotFoundPage.js';
import { PollsPage } from './pages/PollsPage.js';
import { RulesPage } from './pages/RulesPage.js';
import { SettingsPage } from './pages/SettingsPage.js';
import { StandingsPage } from './pages/StandingsPage.js';
import { StatsPage } from './pages/StatsPage.js';
import { useAutoReloadOnUpdate } from './updates.js';

export function App() {
  // A tab left open across a deploy reloads itself onto the new build.
  useAutoReloadOnUpdate();

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="news" element={<NewsPage />} />
        <Route path="news/:slug" element={<NewsPostPage />} />
        <Route path="polls" element={<PollsPage />} />
        <Route path="rules" element={<RulesPage />} />
        <Route path="chats" element={<ChatsPage />} />
        <Route path="standings" element={<StandingsPage />} />
        <Route path="stats" element={<StatsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="admin" element={<AdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
